import { FormFieldType, FormGroupDirectionType, IFormGroupConfig } from '@shared/ui';

export const authFormConfig: IFormGroupConfig = {
  type: FormFieldType.GROUP,
  direction: FormGroupDirectionType.COLUMN,
  fields: {
    username: {
      type: FormFieldType.INPUT,
      placeholder: 'Введите логин',
      hideLabel: true,
      required: true,
    },
    password: {
      type: FormFieldType.PASSWORD,
      placeholder: 'Введите пароль',
      hideLabel: true,
      required: true,
    },
    lawPersonalData: {
      type: FormFieldType.CHECKBOX,
      label: 'Даю согласие в соответствии законом РК ',
      link: '«О персональных данных и их защите»',
      required: true,
    },
    lawInformatization: {
      type: FormFieldType.CHECKBOX,
      label: 'Даю согласие в соответствии законом РК ',
      link: '«Об информатизации»',
      required: true,
    },
  },
};
